import type { Prompt } from "@1js/pl-card-components";
import DOMPurify from "dompurify";

export const usePromptActions = () => {
  const handleCopyClicked = (
    prompt: Prompt,
    onSuccess: (prompt: Prompt) => void
  ) => {
    let copiedCommand = prompt.CommandText;
    if (!prompt.Products?.includes("BizChat")) {
      copiedCommand = DOMPurify.sanitize(prompt.CommandText, {
        IN_PLACE: true,
      });
    }

    navigator.clipboard.writeText(copiedCommand);
    onSuccess(prompt);
  };

  return {
    handleCopyClicked,
  };
};
